// Types
export type {
  EulerIndexerEVault,
  EulerIndexerEVaultsResponse,
  EulerIndexerStrategy,
  NormalizedEVaultInfo,
  EVaultCacheEntry,
  EVaultDataSourcePriority,
  EVaultFetcherConfig,
} from './types'

// EVault Query (Euler Indexer)
export {
  eulerEVaultsQueryKey,
  eulerEVaultsQueryOptions,
  useEulerIndexerEVaults,
  useEulerIndexerEVault,
  usePrefetchEulerEVaults,
  getEVaultFromCache,
  setEVaultInCache,
} from './evaultsQuery'

// Onchain EVault Fetcher (Fallback)
export { fetchEVaultOnchain, fetchEVaultsOnchain } from './onchainEVaultFetcher'

// Combined Hook (Indexer-first, Onchain-fallback)
export {
  useEVaultInfo,
  useEVaultsInfo,
  getEVaultFromMap,
  useEVaultAddresses,
  useEVaultsList,
} from './useEVaultInfo'

